module.exports = __webpack_public_path__ + "img/daszki.648ddfae.jpeg";